import * as React from 'react';
import { Licenses } from "../../../../../Licenses";
import licensesData from "../../../../../Licenses/data/licenses.json";
import * as main from "../../../styles/main.module.scss";
import * as licenses from "../../../styles/licenses.module.scss";

export const EduLicenses = ({ background }) => {
  return (
    <section className={licenses.licenses}>
      <div className={"container"}>
        <div className={licenses.licenses__container} style={{ background: background }}>
          <h2 className={main.mainTitle}>Мы развиваем образование</h2>
          <Licenses data={ licensesData } />
        </div>
      </div>
    </section>
  );
};
